<div
  [class]="`post-icon post-icon--${type}`"
  [class.post-icon--inline]="inline"
  [class.post-icon--clickable]="clickable"
>
  <mat-icon class="post-icon__icon">
    @switch (type) {
      @case ("Discussion") {
        message
      }
      @case ("Question") {
        help
      }
      @case ("Poll") {
        poll
      }
    }
  </mat-icon>
</div>
